import React from 'react';
import { Tooltip } from '../TooltipV2/Tooltip';
import './RoleBadje.scss'

const RoleBadje = ({ role, isNote = false, customClassName = '', style = {} }) => {
    // Конфигурация бейджей
    const getBadgeConfig = (roleValue) => {
        const configs = {
            owner: {
                baseClass: 'role__admin-badge',
                text: 'Автор',
                tooltip: 'Автор может добавлять, удалять, переименовывать и перемещать файлы в директории (в которых он является автором или соавтором)'
            },
            viewer: {
                baseClass: 'role__badge-viewer',
                text: 'Читатель',
                tooltip: 'Читатель может просматривать и скачивать файлы'
            },
            collaborator: {
                baseClass: 'role__user-badge',
                text: 'Соавтор',
                tooltip: 'Соавтор может добавлять, удалять, переименовывать и перемещать файлы в директории (в которых он является автором или соавтором)'
            }
        };

        if (roleValue && configs[roleValue]) {
            return configs[roleValue];
        }

        return {
            baseClass: 'role__badge',
            text: 'Нет прав',
            tooltip: 'Нет прав для просмотра, перемещения, удаление файлов'
        };
    };

    const config = getBadgeConfig(role);
    const noteClass = isNote ? `${config.baseClass}_note` : '';
    const className = [config.baseClass, noteClass, customClassName]
        .filter(Boolean)
        .join(' ');

    return <Tooltip
        text={config.tooltip}
        maxWidth='110px'
        child={
            <div
                className={className}
                style={style}>
                {config.text}
            </div>
        }
    />

};

export default RoleBadje;